export default __webpack_public_path__ + "static/media/infra-19.68b6a198.webp";